import { StoreButtons } from "../components/StoreButtons";
import { RichText, useSiteTranslation } from "../i18n";
import floral from "../../../pictures/home/floral.png";
import heroPhone from "../../../pictures/home/hero-phone.webp";
import maryam from "../../../pictures/home/maryam.jpg";
import zain from "../../../pictures/home/zain.jpg";
import fatima from "../../../pictures/home/fatima.jpg";
import "../styles/hero.css";

export function HeroSection() {
  const { t } = useSiteTranslation();

  return (
    <section className="hero" id="top">
      <img className="hero-floral hero-floral-left" src={floral} alt="" aria-hidden="true" />
      <img className="hero-floral hero-floral-right" src={floral} alt="" aria-hidden="true" />
      <div className="wrap hero-grid">
        <div className="hero-copy" data-reveal>
          <p className="eyebrow hero-eyebrow">
            <span aria-hidden="true" />
            {t("home.hero.eyebrow")}
            <span aria-hidden="true" />
          </p>
          <h1>
            <RichText k="home.hero.title" />
          </h1>
          <p className="hero-script">{t("home.hero.script")}</p>
          <p className="hero-lead">{t("home.hero.lead")}</p>

          <StoreButtons id="download" className="hero-store-row" />

          <div className="hero-proof">
            <div className="proof-avatars" aria-hidden="true">
              {[maryam, zain, fatima].map((src) => (
                <img key={src} src={src} alt="" />
              ))}
            </div>
            <p>
              <b>{t("home.hero.proofTitle")}</b>
              <span>{t("home.hero.proofText")}</span>
            </p>
          </div>
        </div>

        <div className="hero-stage" data-reveal style={{ "--delay": ".12s" }}>
          <img className="hero-composite" src={heroPhone} alt={t("home.hero.imageAlt")} />
        </div>
      </div>
    </section>
  );
}
